/**
 * Cart lines and checkoutSale.itemDetails must agree on what "is a promo line"
 * means before they can be matched against each other.
 *
 * Lines added by the current addToCart always carry isPromo: false, but carts
 * persisted before the promo changes (localStorage shopState, or a server-saved
 * cartJson) have no isPromo property at all. The API returns isPromotion as a
 * real boolean, so `undefined === false` fails and the line matches nothing.
 * Normalize both sides through here instead of comparing the raw values.
 */
export const isPromoLine = (value) => value === true;

/** Single key format for every cart line <-> item detail lookup. */
/** `${line.stockItemId}-${line.isPromo}` */
export const cartLineKey = (stockItemId, isPromo) =>
    `${stockItemId}-${isPromoLine(isPromo) ? 1 : 0}`;

/**
 * Backfills isPromo on cart lines coming from a persisted cart (localStorage
 * shopState or a server-saved cartJson) so downstream matching never has to
 * deal with a missing flag.
 */
export const normalizeCartLines = (lines) =>
    Array.isArray(lines)
        ? lines.map(line => (line && line.isPromo === undefined
            ? { ...line, isPromo: false }
            : line))
        : lines;
